export const SET_CONSELHEIROS = "CONSELHEIROS/SET_CONSELHEIROS";
export const SET_CONSELHEIRO = "CONSELHEIROS/SET_CONSELHEIRO";
export const SET_MANDATOS = "CONSELHEIROS/SET_MANDATOS";
export const SET_PAGINATION = "CONSELHEIROS/SET_PAGINATION";
export const SET_LOADING = "CONSELHEIROS/SET_LOADING";
